import React, { FunctionComponent, useRef } from 'react';

import styles from './LinkedinJobTab.module.scss';
import ErrorBoundary from 'app/components/ErrorBoundary';
import PrimaryMainTable from 'app/components/Tables/PrimaryMainTable';
import { entitiesApiRoutes } from 'influencers/utils/apiRoutes';
import { _t } from 'app/utils/i18n';
import { useQueryClient } from 'react-query';
import { headerCell } from 'trends/components/TrendsCustmComps/TrendsCustmComps';
import AvatarCell from 'app/components/Tables/Cells/AvatarCell';
import { dateFormatter } from 'app/utils/datePickerFormatter';

interface Props {
  isInfluencerModule: boolean;
  linkedin_profile_id?: number;
}
export const jobsColumns = [
  {
    name: 'title',
    header: headerCell(_t('entities:job_title')),
    defaultFlex: 1,
    render: (value: any) => {
      return (
        <div className="actionsCell">
          <div>
            <AvatarCell text={value?.data?.title} hideImg />
          </div>
        </div>
      );
    },
  },
  {
    name: 'status',
    header: headerCell(_t('entities:job_status')),
    defaultFlex: 1,
    render: (value: any) => <p>{value.data.status}</p>,
  },
  {
    name: 'posted_on',
    header: headerCell(_t('entities:post_on')),
    defaultFlex: 1,
    sortable: true,
    render: (value: any) => (
      <p>
        {value.data.posted_on ? dateFormatter(value.data.posted_on) : '_'}
      </p>
    ),
  },
];
const LinkedinJobTab: FunctionComponent<Props> = ({ linkedin_profile_id }) => {
  const queryClient = useQueryClient();
  const influencerDetails: any = queryClient.getQueryData('influencerDetails');
  const ref = useRef<any>();
  React.useEffect(() => {
    ref.current?.loadData({ page: 1 });
  }, [ref.current]);


  return (
    <div className={styles.LinkedinJobTab}>
      <ErrorBoundary>
        <PrimaryMainTable
          moduleName={entitiesApiRoutes().LinkedJobsTab}
          activeTab="jobs"
          columns={jobsColumns}
          title={_t('entities:jobs')}
          initialFilters={{ influencer_id: influencerDetails?.influencer_id }}
          customRequiredFilters={{
            linkedin_profile_id,
            influencer_id: influencerDetails?.influencer_id,
          }}
          hideCheckbox
          ref={ref}
          compId={''}
        />
      </ErrorBoundary>
    </div>
  );
};

export default LinkedinJobTab;
